import { Box, useMediaQuery } from "@material-ui/core"

const cardSx = {
  display: "inline-flex",
  alignItems: "center",
  gap: "0.85rem",
  height: "2.4rem",
  padding: "0.38rem 0.8rem",
  borderRadius: "4px",
  border: "1px solid rgba(173, 227, 255, 0.2)",
  backgroundColor: "#237ca6ad",
  color: "rgba(255, 255, 255, 0.96)",
  boxSizing: "border-box",
  lineHeight: 1,
}

const trackSx = {
  display: "flex",
  alignItems: "center",
  width: "210px",
  minWidth: "180px",
  flex: "0 0 auto",
}

const barSx = {
  position: "relative",
  width: "100%",
  height: "0.5rem",
  minWidth: "110px",
  borderRadius: "9999px",
  overflow: "hidden",
  backgroundColor: "#739ab2",
}

const labelStyle = {
  fontSize: "0.82rem",
  fontWeight: 700,
  color: "rgba(255, 255, 255, 0.88)",
  whiteSpace: "nowrap",
}

function getFillColor(pct) {
  if (pct >= 90) return "#f87171"
  if (pct >= 70) return "#fbbf24"
  return "#4abef0"
}

export default function UsageIndicator({ label, used, total }) {
  const isMobile = useMediaQuery("(max-width:900px)")
  const hasCap = total != null && total > 0
  const pct = hasCap ? Math.min(100, Math.round((used / total) * 100)) : 0
  const fillColor = getFillColor(pct)

  return (
    <Box
      sx={{
        ...cardSx,
        minHeight: isMobile ? "1.8rem" : cardSx.height,
        padding: isMobile ? "0.12rem 0.5rem" : cardSx.padding,
        gap: isMobile ? "0.45rem" : cardSx.gap,
      }}
    >
      <div style={{ ...labelStyle, fontSize: isMobile ? "0.72rem" : labelStyle.fontSize }}>
        {label}:{" "}
        <span style={{ color: "rgba(255, 255, 255, 0.96)", fontWeight: 400 }}>
          {used}
        </span>
        {" / "}
        {hasCap ? total : "-"}
      </div>
      {!isMobile && hasCap && (
        <Box sx={trackSx}>
          <Box sx={barSx}>
            <Box
              sx={{
                position: "absolute",
                inset: 0,
                width: `${pct}%`,
                borderRadius: "9999px",
                background: `linear-gradient(90deg, ${fillColor} 0%, ${fillColor} 100%)`,
              }}
            />
          </Box>
        </Box>
      )}
    </Box>
  )
}
